// src/App.js
import React from 'react';
import useMeta from '../../hooks/useMeta';

import Navbar from '../../CommonComponent/Navbar/Navbar'; // Importing the Navbar component
import Footer from '../../CommonComponent/Footer/footer';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';


//page component

import FAQcontent from './PageComponent/FAQcontent';

function FAQ() {

    useMeta({
        title: 'Frequently Asked Questions | Callistus Blinds',
        description: 'Discover premium window treatments at Callistus Blinds. Explore our extensive range of stylish blinds and shades to enhance your home’s aesthetic and comfort.',
        canonical: 'https://callistusblinds.com/frequently-asked-questions/',
        og: {
            locale: 'en_US',
            type: 'article',
            title: 'Frequently Asked Questions | Callistus Blinds',
            description:
                'Discover premium window treatments at Callistus Blinds. Explore our extensive range of stylish blinds and shades to enhance your home’s aesthetic and comfort.',
            url: 'https://callistusblinds.com/frequently-asked-questions/',
            site_name: 'Callistus Blinds',
        },
    });

    return (
        <div>
            <Navbar />
            <NotificationBar />
            <FAQcontent />
            <Footer />
        </div>
    );
}

export default FAQ;
